<template>
  <section class="invoice-detail-total-section">
    <text-row class="bold"
              left="Factuurtotaal"
              :right="formatPriceToEuroString(proforma.total_vat_free + proforma.total_excl_vat)"/>
  </section>
</template>

<script lang="ts" setup>
import TextRow from '@app/components/TextRow.vue';
import { formatPriceToEuroString } from '@pidz/utils';
import { Proforma } from '../types';

defineProps<{
  proforma: Proforma;
}>();
</script>
